export default "__VITE_ASSET__CB3XgvYF__"